import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ProfilePage = ({ user, setUser }) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('history');

  const orderHistory = [
    { id: 'ORD-001', date: '2026.03.02', item: '3인용 소파', status: '배송 완료', price: '35,000원', rating: 5 },
    { id: 'ORD-002', date: '2026.02.25', item: '대형 냉장고', status: '배송 완료', price: '42,000원', rating: 5 },
    { id: 'ORD-003', date: '2026.02.18', item: '퀸 침대', status: '배송 완료', price: '28,000원', rating: 4 },
    { id: 'ORD-004', date: '2026.03.03', item: '옷장 (대형)', status: '진행 중', price: '39,000원', rating: null },
  ];

  const managerInfo = {
    registered: false,
    level: null,
  };

  const stats = [
    { label: '총 이용 건수', val: '4건', icon: '📦' },
    { label: '절약한 금액', val: '58,000원', icon: '💰' },
    { label: '평균 평점', val: '4.8 ⭐', icon: '⭐' },
    { label: '이달 이용', val: '2건', icon: '📅' },
  ];

  const menuItems = [
    { section: '서비스', items: [
      { icon: '📦', label: '배송 이력', action: () => setActiveTab('history') },
      { icon: '🚚', label: '배송 추적', action: () => navigate('/tracking') },
      { icon: '💰', label: '요금 계산기', action: () => navigate('/pricing') },
      { icon: '🔍', label: '공차 찾기', action: () => navigate('/truck-match') },
    ]},
    { section: '매니저/기사', items: [
      { icon: '🧑‍💼', label: '영차매니저 등록', action: () => navigate('/manager-register'), badge: '수익 창출' },
      { icon: '🚛', label: '용달차 등록', action: () => navigate('/truck-register'), badge: '공차 매칭' },
    ]},
    { section: '계정', items: [
      { icon: '👤', label: '프로필 수정', action: () => {} },
      { icon: '🔔', label: '알림 설정', action: () => {} },
      { icon: '📞', label: '고객센터', action: () => alert('고객센터: 1588-XXXX\n운영시간: 09:00~18:00') },
      { icon: '📋', label: '이용약관', action: () => {} },
      { icon: '🚪', label: '로그아웃', action: () => { setUser && setUser(null); navigate('/login'); } },
    ]},
  ];

  return (
    <div className="page-white">
      {/* 헤더 */}
      <div style={{ background: 'linear-gradient(135deg, #2C3E50 0%, #34495E 100%)', padding: '24px 20px' }}>
        {/* 프로필 */}
        <div style={{ display: 'flex', gap: 16, alignItems: 'center', marginBottom: 20 }}>
          <div style={{
            width: 64, height: 64, borderRadius: '50%',
            background: 'rgba(255,255,255,0.15)', display: 'flex',
            alignItems: 'center', justifyContent: 'center', fontSize: 30,
            border: '2px solid rgba(255,255,255,0.3)'
          }}>
            {user ? '😊' : '👤'}
          </div>
          <div style={{ flex: 1 }}>
            {user ? (
              <>
                <div style={{ color: 'white', fontWeight: 800, fontSize: 18 }}>{user.name}</div>
                <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 13 }}>{user.phone}</div>
                <div style={{ background: '#FF6B35', color: 'white', display: 'inline-block', borderRadius: 6, padding: '2px 8px', fontSize: 11, fontWeight: 700, marginTop: 4 }}>
                  일반 회원
                </div>
              </>
            ) : (
              <>
                <div style={{ color: 'white', fontWeight: 700, fontSize: 16, marginBottom: 4 }}>
                  로그인이 필요합니다
                </div>
                <button
                  onClick={() => navigate('/login')}
                  style={{
                    background: '#FF6B35', color: 'white', border: 'none',
                    borderRadius: 8, padding: '8px 16px', fontWeight: 700,
                    cursor: 'pointer', fontSize: 13
                  }}
                >
                  로그인 / 회원가입
                </button>
              </>
            )}
          </div>
        </div>

        {/* 통계 */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 8 }}>
          {stats.map((s, i) => (
            <div key={i} style={{
              background: 'rgba(255,255,255,0.1)', borderRadius: 10,
              padding: '10px 6px', textAlign: 'center'
            }}>
              <div style={{ fontSize: 18, marginBottom: 4 }}>{s.icon}</div>
              <div style={{ color: 'white', fontWeight: 800, fontSize: 13, marginBottom: 2 }}>{s.val}</div>
              <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: 9 }}>{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* 탭 */}
      <div style={{ display: 'flex', borderBottom: '2px solid #E5E7EB' }}>
        {[
          { key: 'history', label: '📦 이용 내역' },
          { key: 'menu', label: '⚙️ 설정' },
        ].map(tab => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            style={{
              flex: 1, padding: '14px', border: 'none',
              background: 'white', cursor: 'pointer',
              fontWeight: 700, fontSize: 14,
              color: activeTab === tab.key ? '#FF6B35' : '#9CA3AF',
              borderBottom: `3px solid ${activeTab === tab.key ? '#FF6B35' : 'transparent'}`,
              marginBottom: -2, transition: 'all 0.2s'
            }}
          >{tab.label}</button>
        ))}
      </div>

      {/* 이용 내역 탭 */}
      {activeTab === 'history' && (
        <div style={{ padding: '16px 20px 100px' }}>
          {orderHistory.map(order => (
            <div
              key={order.id}
              style={{
                background: 'white', borderRadius: 16, padding: 16, marginBottom: 12,
                border: '1px solid #E5E7EB', boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                cursor: 'pointer'
              }}
              onClick={() => navigate('/tracking')}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 15, color: '#1F2937' }}>{order.item}</div>
                  <div style={{ fontSize: 12, color: '#9CA3AF', marginTop: 2 }}>{order.date}</div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{
                    padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700,
                    background: order.status === '배송 완료' ? '#e8f8ef' : '#e8f4fd',
                    color: order.status === '배송 완료' ? '#27AE60' : '#2980B9'
                  }}>
                    {order.status}
                  </div>
                  <div style={{ fontWeight: 700, color: '#FF6B35', marginTop: 4 }}>{order.price}</div>
                </div>
              </div>

              {order.rating ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <span style={{ color: '#F39C12', fontSize: 14 }}>{'⭐'.repeat(order.rating)}</span>
                  <span style={{ fontSize: 12, color: '#9CA3AF' }}>리뷰 완료</span>
                </div>
              ) : (
                <button
                  onClick={e => { e.stopPropagation(); alert('배송이 완료되면 리뷰를 작성할 수 있습니다'); }}
                  style={{
                    background: '#FFF0EB', color: '#FF6B35', border: 'none',
                    borderRadius: 8, padding: '6px 12px', fontSize: 12, fontWeight: 700, cursor: 'pointer'
                  }}
                >
                  배송 추적 →
                </button>
              )}
              <div style={{ fontSize: 11, color: '#9CA3AF', marginTop: 4 }}>주문번호: {order.id}</div>
            </div>
          ))}

          {/* 서비스 유도 배너 */}
          <div style={{
            background: 'linear-gradient(135deg, #FF6B35, #FF8C5A)',
            borderRadius: 16, padding: 20, marginTop: 8, color: 'white', textAlign: 'center'
          }}>
            <div style={{ fontWeight: 800, fontSize: 16, marginBottom: 4 }}>🚐 첫 이용 혜택!</div>
            <div style={{ fontSize: 13, opacity: 0.9, marginBottom: 12 }}>첫 서비스 요청 시 5,000원 할인 쿠폰</div>
            <button
              onClick={() => navigate('/service-select')}
              style={{
                background: 'white', color: '#FF6B35', border: 'none',
                borderRadius: 10, padding: '10px 24px', fontWeight: 700, cursor: 'pointer'
              }}
            >서비스 요청하기 →</button>
          </div>
        </div>
      )}

      {/* 설정 탭 */}
      {activeTab === 'menu' && (
        <div style={{ padding: '16px 20px 100px' }}>
          {menuItems.map((section, si) => (
            <div key={si} style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#9CA3AF', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                {section.section}
              </div>
              <div style={{ background: 'white', borderRadius: 16, overflow: 'hidden', border: '1px solid #E5E7EB' }}>
                {section.items.map((item, ii) => (
                  <div
                    key={ii}
                    onClick={item.action}
                    style={{
                      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                      padding: '16px', cursor: 'pointer',
                      borderBottom: ii < section.items.length - 1 ? '1px solid #F3F4F6' : 'none',
                      transition: 'background 0.2s'
                    }}
                  >
                    <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                      <span style={{ fontSize: 20 }}>{item.icon}</span>
                      <span style={{ fontWeight: 500, fontSize: 15, color: item.label === '로그아웃' ? '#E74C3C' : '#1F2937' }}>
                        {item.label}
                      </span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      {item.badge && (
                        <span style={{ background: '#FFF0EB', color: '#FF6B35', padding: '2px 8px', borderRadius: 6, fontSize: 11, fontWeight: 700 }}>
                          {item.badge}
                        </span>
                      )}
                      {item.label !== '로그아웃' && <span style={{ color: '#9CA3AF' }}>›</span>}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}

          {/* 앱 정보 */}
          <div style={{ textAlign: 'center', color: '#9CA3AF', fontSize: 12, marginTop: 16 }}>
            <div style={{ fontSize: 24, marginBottom: 6 }}>🚐</div>
            <div style={{ fontWeight: 700 }}>어디용차 v1.0.0</div>
            <div style={{ marginTop: 4 }}>가는 길에, 믿고 맡기세요</div>
            <div style={{ marginTop: 8, color: '#D1D5DB' }}>© 2026 (주)어디용차 All rights reserved.</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfilePage;
